import type { ReactNode } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import EmptyState from '@atlaskit/empty-state';
import { token } from '@atlaskit/tokens';

type EmptyStateWrapperProps = {
	header: string;
	description: ReactNode;
	primaryAction?: ReactNode;
	imageUrl: string;
	imageHeight: number;
	maxImageWidth?: number;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EmptyStateContainer = styled.div({
	margin: `${token('space.0', '0px')} ${token('space.050', '4px')}`,
	padding: `${token('space.0', '0px')} ${token('space.075', '6px')}`,
});

export const EmptyStateWrapper = (emptyStateProps: EmptyStateWrapperProps) => {
	return (
		<EmptyStateContainer>
			<EmptyState {...emptyStateProps} />
		</EmptyStateContainer>
	);
};
